<template>
  <div class="newsList">
    <div class="contentrows_box">
      <div class="head">
        <img src="@/assets/back.png" class="back" type="primary" @click="goBack">
      </div>
      <div style="margin: 20px 30px 0 30px;">
        <div class="title_box">
          <div class="title">基本信息</div>
        </div>

        <div>
          <el-form-item label="标题">
            <el-col>
              <el-input v-model="title" placeholder="请输入标题" clearable />
            </el-col>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="截止日期">
            <el-date-picker
                v-model="endTime"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </div>

        <div>
          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" :class="ck-editor__editable"></ckeditor>
          <el-button type="success" @click="admit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import time from '@/core/time.js';
import ClassicEditor from "@/ckeditor/ckeditor";
import {ElLoading} from "element-plus";
export default {
  data() {
    return {
      type: '',
      coverUrl: [],
      endTime: '',
      title: '',
      content: '',
      userId: '',
      id: '',
      input: '',
      editor: ClassicEditor,
      editorConfig: {
        min_height: 800,
        // The configuration of the editor.
        toolbar: ['heading', '|', 'bold', 'italic', 'alignment', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'outdent', 'indent' , '|', 'uploadImage', 'mediaEmbed','insertTable','|', 'undo', 'redo'],
        simpleUpload: {
          uploadUrl: '/api3/config/fileInfo/uploadImg',
          withCredentials: false,
        },
        mediaEmbed: {   // 视频配置
          previewsInData: true,
          providers: [
            {
              name: 'myprovider',
              url: [
                /^lizzy.*\.com.*\/media\/(\w+)/,
                /^www\.lizzy.*/,
                /(http|https):\/\/([\w.]+\/?)\S*/
              ],
              html: match => {
                //获取媒体url
                const input = match['input'];
                return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 70%;">' +
                    // 'video controls="controls" autoplay name="media" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"'+
                    // `source src="${input}" type="video/mp4"`+
                    // '/video'+
                    `<iframe src="${input}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                );
              }
            }
          ]
        }
      },
      editorData: '',
      totalNum: 0, pageNum: 1, pageSize: 6,
      news: [],
    }
  },
  watch: {},
  created() {
    this.id = this.$route.query.id;
    this.newsSelect();
  },
  mounted() {

  },
  methods: {
    getImgSrc(richtext) {
      richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
        this.coverUrl.push(capture);
      });
      return this.coverUrl;
    },
    admit() {
      if(this.endTime==''){
        this.$msg.warning('请输入截止日期')
      }else{
        if(this.title==''&&this.editorData==''){
          this.$msg.warning('请输入标题和正文')
        }else if(this.title==''&&this.editorData!=''){
          this.$msg.warning('请输入标题')
        }else if(this.title!=''&&this.editorData==''){
          this.$msg.warning('请输入正文')
        }else if(this.title!=''&&this.editorData!=''&&this.radio!=''&&this.companyId!=''){
          this.getImgSrc(this.editorData);
          console.log("图片地址",this.coverUrl[0])
          let data = {
            id: this.id,
            title: this.title,
            content: this.editorData,
            type: 1,
            coverUrl: this.coverUrl[0],
            endTime: this.endTime
            // userId:this.$store.getters.userId,
          }
          // //debugger
          let url = '/ArAssess/updateAssess'
          this.$request.post(url,data).then(res=>{
            console.log(res)
          })
          this.$msg.success('提交成功')
          this.$router.push({
            path: '/myAssess',
            query: {
              id: this.id,
            }
          })
        }
      }
    },


    // newsSelect() {
    //   let data = {
    //     id: this.id,
    //     type:2
    //   };
    //   let url = '/ArAssess/selectAssess';
    //   this.$request.post(url, data).then(data => {
    //     this.title = data.obj.assess.title;
    //     this.editorData = data.obj.assess.editorData;
    //     this.endTime=data.obj.assess.endTime;
    //     this.userId = this.$store.getters.userId;
    //   })
    // },

    newsSelect() {
      //console.log(this.id)
      let id = this.id;
      if (id != '' && id != null && id != undefined) {
        console.log('no')
        let url = '/ArAssess/selectAssess';
        this.$request.post(url, id).then(data => {
          this.title = data.obj.assess.title;
          this.editorData = data.obj.assess.content;
          this.endTime = data.obj.assess.endTime;
        })
      }
      //debugger
    },
    showNews(value) {
      this.$router.push({
        path: '/assessShow',
        query: {
          id: value.id,
        }
      })
    },

  }
}
</script>
<style lang="less">

.ck-editor__editable {
  min-height: 500px;
  word-break:break-all;
}
.head{
  .back{
    margin-left: 30px;
    margin-top: 20px;
    width: 80px;
    height: 40px;
  }
  .back:hover{
    cursor: pointer;
  }
}

.newsList {
  width: 100%;
  height: 100%;
  background: white;

  .contentrows_box {
    height: 97%;
    border-radius: 20px;
    background: white;
    width: 95%;
    margin-left: 2.5%;
    margin-top: 2.5%;
    box-shadow: 0px 0px 10px 0 #d0d2d3;

    .contentrows {
      margin: auto;
      width: 860px;
      padding-top: 50px;

      .row_box {
        width: 860px;
      }

      .row {
        height: 80px;
        width: 840px;
        border-bottom: 2px dotted #D4D4DC;

        .row_date {
          display: flex;
          float: left;
          width: 82px;

          .row_date_left {
            height: 60px;
            margin-top: 20px;
            font-size: 35px;
            line-height: 70px;
          }

          .row_date_right {
            height: 40px;
            margin-top: 34px;
            padding-left: 5px;

            .row_date_month {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }

            .row_date_year {
              height: 20px;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }

        .row_content {
          margin-top: 40px;
          line-height: 40px;
          height: 30px;
          padding-left: 20px;
          margin-left: 10px;
          width: 600px;
          float: left;
          border-left: 6px solid #CDD9E9;

          .row_title {
            overflow: hidden;
            width: 400px;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            float: left;
          }

          .row_title:hover {
            cursor: pointer;
          }

          .row_name {
            font-size: 13px;
            width: 200px;
            color: #a8a8ac;
            float: right;
            text-align: right;
          }
        }

        .el-button {
          background: #3A63B3;
          height: 20px;
          width: 80px;
          margin-top: 45px;
          margin-right: 30px;
          font-size: 13px;
          line-height: 2px;
          border-radius: 0;
          float: right;
        }
      }

    }

    .page {
      height: 100px;
      width: 860px;
      margin: auto;
      position: relative;

      .el-pager {
        li {
          border: 1px solid #dcdfe6;
          margin-right: 10px;
          background-color: white;
        }

        li:not(.disabled).active {
          background-color: #3A62FE;
          color: white;
        }

        li:hover {
          color: #3A62FE;
        }
      }

      .btn-prev {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        margin-left: 10px;
        background-color: white;
      }

      .btn-next {
        border: 1px solid #dcdfe6;
        margin-right: 10px;
        background-color: white;
      }

      .el-pagination {
        position: absolute;
        bottom: 30px;
        right: 0;

        .el-pagination__sizes {
          float: right;

          .el-input__inner {
            color: #5D61AA;
            font-weight: bold;
          }
        }
      }
    }
  }
}

</style>
